module.exports = __webpack_public_path__ + "static/media/main idea.54791f67.mp3";